module.exports = __webpack_public_path__ + "static/img/Graphics1@3X.ab89ef0.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Graphics1@3X.png
// module id = SOsQ
// module chunks = 1